// Редовете на „Целия списък" в листа „Доставка" (изнесено от страницата):
// каталогът (`catalogItemsOf`) + въвеждането в реда — редовете на листа,
// разфасовките им и избран ли е доставчик (чипът „От този доставчик").
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { LastPrice, Packaging, Product, StockBalance } from "../../../../api/inventory";
import { catalogItemsOf } from "./deliveryWorksheetHelpers";
import type { DeliveryRowDraft } from "./deliveryWorksheetShared";

type Params = {
  products: Product[];
  balanceByProduct: Map<number, StockBalance>;
  lastPriceByProduct: Map<number, LastPrice>;
  addedSet: Set<number>;
  decimalsOf: (productId: number) => number;
  rowOf: (productId: number) => DeliveryRowDraft;
  packagingById: Map<number, Packaging>;
  supplierId: number | null;
};

export const useDeliveryCatalogItems = ({
  products,
  balanceByProduct,
  lastPriceByProduct,
  addedSet,
  decimalsOf,
  rowOf,
  packagingById,
  supplierId,
}: Params) => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      catalogItemsOf(products, balanceByProduct, lastPriceByProduct, addedSet, decimalsOf, t, {
        rowOf,
        packagingById,
        supplierSelected: supplierId != null,
      }),
    [products, balanceByProduct, lastPriceByProduct, addedSet, decimalsOf, t, rowOf, packagingById, supplierId],
  );
};
